import React from 'react';
import PropTypes from 'prop-types';
import cancelEvent from '../../../services/mini/cancelEvent';

class FilterCheckbox extends React.Component {

    shouldComponentUpdate(nextProps) {
        let curProps = this.props;

        if (curProps.value !== nextProps.value) {
            return true;
        }

        if (curProps.count !== nextProps.count) {
            return true;
        }

        if (curProps.classes !== nextProps.classes) {
            return true;
        }

        return false;
    }

    onClick = (e) => {
        // console.info('== onClick');
        const {
            onClick,
        } = this.props;
        onClick(e);
    }

    markLogsAsread = (e) => {
        // console.info('== markLogsAsread');
        const {
            logLevel,
            logFilterType,
            onReadLogs,
            value
        } = this.props;

        if (value) {
            if (onReadLogs) {
                onReadLogs({ logFilterType, logLevel });
            }
            cancelEvent(e);
        }
    }

    render() {
        const {
            label,
            count,
            value,
            type,
            classes,
        } = this.props;

        let hasMessages = count > 0;

        return <div
            className={`filter-checkbox ${value && 'checked'} ${type} ${hasMessages && 'has-messages'} ${classes}`}
            onClick={this.onClick}>
            {label}
            {count > 0 && <span
                className="filter-checkbox_count"
                title={value ? `Click to mark all ${label} logs as read` : ''}
                onClick={value ? this.markLogsAsread : undefined}>
                {count}
            </span>}
        </div>;
    }
}


FilterCheckbox.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    count: PropTypes.number,
    isNew: PropTypes.bool,
    type: PropTypes.string.isRequired,
    classes: PropTypes.string,
};

export default FilterCheckbox;